<template>
  <div id="profile">
    <div class="container">
      <div class="left">
        <img :src="getLeftImageUrl()" v-if="leftImage != null" />
        <span v-if="leftImage == null" v-html="leftText" class="left-text"></span>
      </div>
      <div class="right">
        <div style="display:block">
          <p class="name" v-if="name != null">{{ name }}</p>
          <span class="text" v-html="rightText"></span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Profile",
  props: {
    leftImage: {
      type: String,
      default: null
    },
    leftText: {
      type: String,
      default: ""
    },
    name: {
      type: String,
      default: null
    },
    rightText: {
      type: String,
      default: "",
      required: true
    }
  },
  methods: {
    getLeftImageUrl() {
      return require(`@/assets/${this.leftImage}`);
    }
  }
};
</script>

<style scoped>
#profile {
  text-align: center;
}
.container {
  width: 100%;
  display: inline-flex;
  flex-flow: row wrap;
  justify-content: center;
}
.left {
  flex-basis: 40%;
  padding: 10px;
  display: flex;
}
.right {
  flex-basis: 55%;
  text-align: left;
  padding: 10px;
  display: flex;
}
.left .left-text {
  margin-left: auto;
  font-size: 120%;
  font-weight: bolder;
}
p.name {
  font-weight: bold;
  font-size: 110%;
  margin: 0 0 12px 0;
}
img {
  margin-left: auto;
  width: 150px;
  height: 150px;
}
</style>